import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { ApiService } from './api.service';
import { createClient } from 'urql'
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root',
})

export class MainService {
  constructor(private apiService: ApiService) {}

  getAllMissions(id){
    return this.apiService.post('/api/missions',{})
  }

  getMyMissions(userId:number){
    return this.apiService.post('/api/missions/my',{userId:userId})
  }

  deployToMissions(userId:number,soldiers:any, items:any){
    return this.apiService.post('/api/missions/deploy',{userId:userId, soldiers:soldiers, items:items});
  }

  desertMissions(userId:number, missionId:any){
    return this.apiService.post('/api/missions/deserter',{userId:userId, missionId:missionId})
  }

  getUser(wallet: string){
    return this.apiService.post('/auth/user',{wallet:wallet})
  }

  updateAvatar(userId:string, url:string, username:string){
    return this.apiService.post('/Auth/avatar',{id:userId, url:url, username:username});
  }

  purchaseInventory(userId:number, inventoryId:number, quantity:number){
    return this.apiService.post('/api/purchase/inventory',{userId:userId, inventoryId:inventoryId, quantity:quantity});
  }

  getInventory(){
    return this.apiService.post('/api/inventory',{});
  }

  myInventory(userId:any){
    return this.apiService.post('/api/inventory/my',{userId:userId});
  }

  useItem(userId:any, itemId:any){
    return this.apiService.post('/api/missions/item',{ userId:userId, itemId:itemId });
  }

  streetcred(userId:any){
    return this.apiService.post('/api/auth/streetcre',{ userId:userId });
  }

  claim(userId:number, missionId:number ){
    return this.apiService.post('/api/missions/claim',{userId:userId, missionId:missionId});
  }

  levels(){
    return this.apiService.post('/api/missions/levels',{});
  }

  scoreboard(skillId:number, userId:number){
    return this.apiService.post('/api/leaderboard',{skillId:skillId, userId:userId});
  }

  getSeasons(){
    return this.apiService.post('/api/missions/seasons',{});
  }

  claimRewards(userId:number, rewardId:number ){
    return this.apiService.post('/auth/reward',{userId:userId, burnId:rewardId});
  }

  claimSeasonRewards(userId:number ){
    return this.apiService.post('/auth/seasonreward',{userId:userId});
  }

  packSignature(userId:number, type:any, quantity:number ){
    return this.apiService.post('/api/purchase/pack',{userId:userId, inventoryId:38, quantity:quantity, type:type});
  }

  packOpen(tokenId:number, userId:number){
    return this.apiService.post('/auth/openpack',{tokenId:tokenId, userId:userId});
  }

  upgradeNFT(tokenId:number, userId:number){
    return this.apiService.post('/auth/upgrade',{tokenId:tokenId, userId:userId});
  }

  allSell(){
    return this.apiService.post('/api/inventory/allsell',{userId:null});
  }

  listSellItem(userId:number, userItemId:number, price:number){
    return this.apiService.post('/api/inventory/sell',{userId:userId, userItemId:userItemId, price:price});
  }

  cancelSellItem(userId:number, sell:number){
    return this.apiService.post('/api/inventory/cancel',{userId:userId, sell:sell});
  }

  purchaseSellItem(userId:number, userSell:number){
    return this.apiService.post('/api/inventory/purchase',{userId:userId, userSell:userSell});
  }

  getNFTs(userId:number){
    console.log(userId)
    return this.apiService.post('/auth/nfts',{userId:userId});
  }

  getPacks(userId:number){
    return this.apiService.post('/auth/packs',{userId:userId});
  }

  getETH(userId:number){
    return this.apiService.post('/auth/eth',{userId:userId});
  }

  getPassSig(userId:number, ids:any[]){
    return this.apiService.post('/api/purchase/burnPass',{userId:userId, inventoryId:38, ids:ids, type:'BURN'});
  }

  opensea(tokenId:number){
    return this.apiService.getCustom('https://api.opensea.io/api/v1/asset/'+environment.pack+'/'+tokenId+'/?force_update=true',{
      'Content-Type': 'application/json',
      Accept: 'application/json',
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
      "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With"
    });
  }

}